import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Fuengirola"
      slug="fuengirola"
      poblacion={87007}
      lat={36.5409}
      lng={-4.6261}
      neighborhoodsText="Cubrimos toda Fuengirola: Los Boliches, Los Pacos, El Castillo, Carvajal y la zona del puerto. Atendemos también la comunidad escandinava y británica con técnicos disponibles."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Fuengirola?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Fuengirola?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés, francés y sueco/noruego básico." },
      ]}
    />
  );
}